import axiosClient from "api/axios_client.js";

// Notification bell in the app header (layouts/Header.jsx).

export const getAllNotificationsApi = async (payload) => {
  const res = await axiosClient.post("/notification/get-all", payload);
  return res.data;
};

export const readNotificationApi = async (payload) => {
  const res = await axiosClient.put("/notification/read", payload);
  return res.data;
};
